import { IconButton, IIconProps, Label, Text } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import './PageHeader.Styles.css';

export interface PageHeaderProps {
  title: string;
  subtitle?: string | undefined;
  eyebrow?: string;
}

export const PageHeader = (props: PageHeaderProps) => {
  const BackIcon: IIconProps = { iconName: 'ChevronLeftSmall' };

  const history = useNavigate();

  const handleBackClick = () => {
    history(-1);
  };

  return (
    <div className="PageHeader">
      <IconButton
        iconProps={BackIcon}
        onClick={handleBackClick}
        ariaLabel="Volver"
        title="Volver"
      />
      <div className="ph-textBlock">
        {props.eyebrow && <span className="ph-eyebrow">{props.eyebrow}</span>}
        <Label className="ph-title">{props.title}</Label>
        {props.subtitle && <Text className="ph-subtitle">{props.subtitle}</Text>}
      </div>
    </div>
  );
};
